import React from 'react';

import { H3 } from '../../atoms/Typography';
import Button from '../../atoms/Button';

import {
    STileItem,
    STileText,
    SCtaContainer,
    SCtaAction,
} from './styles';

const TileItem = ({ tileData }) => {
    const { bgColor, content } = tileData;
    const { title, text, cta } = content;
    const {
        text: ctaText,
        type: ctaType,
        action: ctaAction,
    } = cta;

    let hrefByCtaAction;

    switch (ctaAction) {
        case 'email':
            hrefByCtaAction = `mailto:${ title }`;
            break;
        case 'phoneCall':
            hrefByCtaAction = `tel:${ title.replace(/\s+/g, "") }`;
            break;
        default:
            hrefByCtaAction = null;
    }

    return (
        <STileItem background={ bgColor }>
            <H3>
                { title }
            </H3>
            <STileText>
                { text }
            </STileText>
            <SCtaContainer>
                <SCtaAction href={ hrefByCtaAction }>
                    <Button
                        type={ ctaType }
                    >
                        { ctaText }
                    </Button>
                </SCtaAction>
            </SCtaContainer>
        </STileItem>
    );
};

export default TileItem;
